import xws from 'api/xws/';

// Action Types
import * as actionTypes from './actionTypes';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Selectors
import { getWebkey, getQueryParam } from 'store/reducers/queryParams/selectors';
import { getPersonId } from 'store/reducers/user/personInfo/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

import { getVehicle } from 'store/reducers/appointment/selectors';

// Constants
import { getService } from 'constants/ajax';
import qs from 'query-string';

export const getMarketing = () => async (dispatch, getState) => {
  const marketingService = getService('marketing');
  const webkey = getWebkey(getState());
  const token = getQueryParam('token')(getState());
  marketingService.setPathVars({ webkey, token });
  marketingService.setCallBacks(dispatch(ajaxCallbacks()));
  const request = xws(marketingService).get(marketingService.getPath());
  try {
    const {
      data: { data }
    } = await request;
    dispatch(setMarketingData(data));
    return data;
  } catch (e) {
    /* eslint-disable no-console */
    console.log(e);
    /* eslint-enable no-console */
    return false;
  }
};

export const getOptStatus = () => async (dispatch, getState) => {
  const optService = getService('optStatus');
  const webKey = getWebkey(getState());
  const personId = getPersonId(getState());
  optService.setPathVars({ webKey, personId });
  optService.setCallBacks(dispatch(ajaxCallbacks()));
  const request = xws(optService).get(optService.getPath());
  try {
    const {
      data: { data }
    } = await request;
    dispatch(setOptStatus(data));
    return data;
  } catch (e) {
    /* eslint-disable no-console */
    console.log(e);
    /* eslint-enable no-console */
    return false;
  }
};

export const getOptOutCustomerForSMSMarketing = localeCode => async (
  dispatch,
  getState
) => {
  const optOutCustomerForSMSMarketingService = getService(
    'optOutCustomerForSMSMarketing'
  );
  const webKey = getWebkey(getState());
  const personId = getPersonId(getState());
  const vehicle = getVehicle(getState());
  const application = 'DEALER_PORTAL';

  optOutCustomerForSMSMarketingService.setPathVars({
    webKey,
    personId,
    application
  });
  optOutCustomerForSMSMarketingService.setCallBacks(dispatch(ajaxCallbacks()));

  const request = xws(optOutCustomerForSMSMarketingService).get(
    optOutCustomerForSMSMarketingService.getPath(),
    {
      params: {
        vid: vehicle.vehicleId,
        locale: localeCode
      }
    }
  );

  try {
    const {
      data: { data }
    } = await request;

    dispatch(setOptOutCustomerForSMSMarketing(data));
    return data;
  } catch (e) {
    /* eslint-disable no-console */
    console.error('error**', e);
    /* eslint-disable no-console */
    return false;
  }
};

export const getOptInUrl = () => async (dispatch, getState) => {
  const optInUrlService = getService('optInUrl');
  const webKey = getWebkey(getState());
  const personId = getPersonId(getState());
  const vehicle = getVehicle(getState());

  optInUrlService.setCallBacks(dispatch(ajaxCallbacks()));
  const request = xws(optInUrlService).post(
    optInUrlService.getPath(),
    qs.stringify({
      webKey,
      personId,
      vehicleId: vehicle.vehicleId,
      locale: getLocaleCode(getState())
    })
  );

  try {
    const {
      data: { optInURL }
    } = await request;

    dispatch(setOptInUrl(optInURL));
    return optInURL;
  } catch (e) {
    /* eslint-disable no-console */
    console.error('error***', e);
    /* eslint-disable no-console */
    return false;
  }
};

export const cleanOptInUrl = () => (dispatch, getState) => {
  dispatch({
    type: actionTypes.CLEAN_OPT_IN_URL,
    payload: null
  });
};

export const changeOptStatus = nextOptStatus => (dispatch, getState) => {
  dispatch({
    type: actionTypes.CHANGE_OPT_STATUS,
    payload: nextOptStatus
  });
};

const setMarketingData = marketingData => {
  return {
    type: actionTypes.SET_MARKETING_DATA,
    payload: marketingData
  };
};

const setOptStatus = opt => {
  return {
    type: actionTypes.SET_OPT_STATUS,
    payload: opt
  };
};

const setOptOutCustomerForSMSMarketing = data => {
  return {
    type: actionTypes.SET_OPT_OUT_CUSTOMER_FOR_SMS_MARKETING,
    payload: data
  };
};

const setOptInUrl = data => {
  return {
    type: actionTypes.SET_OPT_IN_URL,
    payload: data
  };
};

export const setDefaultPromotion = value => {
  return {
    type: actionTypes.SET_DEFAULT_PROMOTION,
    payload: value
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/marketing/actions.js